import React from 'react';
import { Nav } from 'react-bootstrap';

export default function Email() {
  return (
    <Nav.Link className="text-end" href="mailto:george@auger-construction.com" aria-label="Email Me">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" fill="currentColor" className="bi bi-envelope-fill me-1" viewBox="0 0 16 16">
        <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z"/>
      </svg>
      george@auger-construction.com
    </Nav.Link>
  );
}
